/* eslint-disable */
import { useQuery } from 'vue-query';
import apiAxios from '../apiAxios';
const convertDaysToNumbers = (daysString) => {
  console.log('daysString', daysString.target);
  const dayMap = {
    sunday: 1,
    monday: 2,
    tuesday: 3,
    wednesday: 4,
    thursday: 5,
    friday: 6,
    saturday: 7,
  };

  return daysString
    .split(',')
    .map((day) => dayMap[day.toLowerCase()])
    .join(',');
};
const fetchEmployerStats = async ({ type, year }) => {
  let URL = '';
  if (type) {
    URL += `?type=${type}`;
  }

  if (year) {
    URL += `&from_year=${year}-01-01&to_year=${+year + 1}-01-01`;
  }
  const { data } = await apiAxios.get(`/employer-stats${URL}`);
  return data;
};

const fetchCommuterBenifitsStats = async ({ type, year }) => {
  let URL = '';
  if (type) {
    URL += `?type=${type}`;
  }
  if (year) {
    URL += `&from_year=${year}-01-01&to_year=${+year + 1}-01-01`;
  }
  const { data } = await apiAxios.get(`/commuter-benefits-stats${URL}`);
  return data;
};

const fetchCommuterImpactsStats = async (obj) => {
  const paramsObj = { ...(obj || {}) };
  const searchParams = new URLSearchParams();

  Object.keys(paramsObj).forEach((key) => {
    const val = paramsObj[key];
    if (Array.isArray(val)) {
      // produce key[]=v1&key[]=v2...
      val.forEach((v) => searchParams.append(`${key}[]`, v));
    } else if (val !== undefined && val !== null) {
      searchParams.append(key, val);
    }
  });

  const query = searchParams.toString();
  const url = `/statistics/impacts/${query ? `?${query}` : ''}`;
  const { data } = await apiAxios.get(url);
  return data;
};


const fetchCommuterImpacts2Stats = async (obj) => {
  const paramsObj = { ...(obj || {}) };
  const searchParams = new URLSearchParams();

  Object.keys(paramsObj).forEach((key) => {
    const val = paramsObj[key];
    if (Array.isArray(val)) {
      // produce key[]=v1&key[]=v2...
      val.forEach((v) => searchParams.append(`${key}[]`, v));
    } else if (val !== undefined && val !== null) {
      searchParams.append(key, val);
    }
  });

  const query = searchParams.toString();
  const url = `/statistics/impacts-2/${query ? `?${query}` : ''}`;
  const { data } = await apiAxios.get(url);
  return data;
};

const fetchCommunityFootprintStats = async ({ type, year }) => {
  let URL = '';
  if (type) {
    URL += `?type=${type}`;
  }
  if (year) {
    URL += `&from_year=${year}-01-01&to_year=${+year + 1}-01-01`;
  }
  const { data } = await apiAxios.get(`/community-footprint-stats${URL}`);
  return data;
};

const fetchModeShareStats = async ({
  type,
  from,
  to,
  daySearch,
  connect2,
  from_connect,
  to_connect,
}) => {
  let URL = '';
  if (type) {
    URL += `?type=${type}`;
  }
  if (from && to) {
    URL += `&from_year=${from}&to_year=${to}`;
  }
  if (daySearch) {
    URL += `&searchDay=${daySearch}`;
  }
  if (connect2) {
    if (from_connect && to_connect) {
      URL += `&from_year_connect=${from_connect}&to_year_connect=${to_connect}`;
    }
  }
  const { data } = await apiAxios.get(`/initial-mode${URL}`);
  return data;
};

const fetchMileShareStats = async ({ type, from, to, daySearch }) => {
  let URL = '';
  if (type) {
    URL += `?type=${type}`;
  }
  if (from && to) {
    URL += `&from_year=${from}&to_year=${to}`;
  }
  if (daySearch) {
    URL += `&searchDay=${daySearch}`;
  }
  const { data } = await apiAxios.get(`/mile-share${URL}`);
  return data;
};

const fetchAvgCommuteDistStats = async ({ type, from, to, week }) => {
  let URL = '';
  if (type) {
    URL += `?type=${type}`;
  }
  if (from && to) {
    URL += `&from_year=${from}&to_year=${to}`;
  }

  if (week) {
    URL += `&week=${week}`;
  }

  const { data } = await apiAxios.get(`/avg-commute-distance${URL}`);
  return data;
};

const fetchAvgCommuteModeDistStats = async ({ type, from, to }) => {
  let URL = '';
  if (type) {
    URL += `?type=${type}`;
  }
  if (from && to) {
    URL += `&from_year=${from}&to_year=${to}`;
  }

  const { data } = await apiAxios.get(`/avg-mile-commute-distance${URL}`);
  return data;
};

// queries
const useEmployerStatsQuery = ({ type, year }) =>
  useQuery(['employer-stats', type, year], () => fetchEmployerStats({ type, year }));
const useCommuterBenifitsQuery = ({ type, year }) =>
  useQuery(['commuter-benefits-stats', type, year], () =>
    fetchCommuterBenifitsStats({ type, year }),
  );
  const useCommuterImpactsQuery = (obj) =>
  useQuery(['commuter-impacts-stats', obj], () =>
    fetchCommuterImpactsStats(obj),
  );
  const useCommuterImpacts2Query = (obj) =>
  useQuery(['commuter-impacts-2-stats', obj], () =>
    fetchCommuterImpacts2Stats(obj),
  );

const useCommunityFootprintQuery = ({ type, year }) =>
  useQuery(['community-footprint-stats', type, year], () =>
    fetchCommunityFootprintStats({ type, year }),
  );

const useModeShareQuery = ({
  type,
  from,
  to,
  daySearch,
  connect2 = null,
  from_connect = null,
  to_connect = null,
}) =>
  useQuery(['initial-mode', type, from, to, daySearch, connect2, from_connect, to_connect], () =>
    fetchModeShareStats({ type, from, to, daySearch, connect2, from_connect, to_connect }),
  );

const useMileShareQuery = ({ type, from, to, daySearch }) =>
  useQuery(
    ['mile-share', type, from, to, daySearch],
    () => fetchMileShareStats({ type, from, to, daySearch }),
    {
      cacheTime: 0,
      staleTime: 0,
    },
  );
const useAvgCommuteDistanceQuery = ({ type, from, to, week }) =>
  useQuery(
    ['avg-commute-distance-share', type, from, to],
    () => fetchAvgCommuteDistStats({ type, from, to, week }),
    {
      cacheTime: 0,
      staleTime: 0,
    },
  );
const useAvgCommuteModeDistanceQuery = ({ type, from, to }) =>
  useQuery(
    ['avg-commute-mode-distance-share', type, from, to],
    () => fetchAvgCommuteModeDistStats({ type, from, to }),
    {
      cacheTime: 0,
      staleTime: 0,
    },
  );

export default {
  fetchEmployerStats,
  fetchCommuterBenifitsStats,
  fetchCommunityFootprintStats,
  fetchModeShareStats,
  fetchMileShareStats,
  // queries
  useEmployerStatsQuery,
  useCommuterBenifitsQuery,
  useCommuterImpactsQuery,
  useCommuterImpacts2Query,
  useCommunityFootprintQuery,
  useModeShareQuery,
  useMileShareQuery,
  useAvgCommuteDistanceQuery,
  useAvgCommuteModeDistanceQuery,
};
